import { render, staticRenderFns } from "./SacDashboard.vue?vue&type=template&id=0dd9652c&scoped=true"
import script from "./SacDashboard.vue?vue&type=script&lang=js"
export * from "./SacDashboard.vue?vue&type=script&lang=js"
import style0 from "./SacDashboard.vue?vue&type=style&index=0&id=0dd9652c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd9652c",
  null
  
)

export default component.exports